import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import type { IAddOnPayload } from 'app/typings/addOn';
import { apiMutation } from 'app/utils/request/api';

const path = '/extranet/:hotelId/experiences' as const;

export function useAddOn(hotelId: number) {
  return useMutation({
    mutationFn: async (payload: IAddOnPayload) =>
      apiMutation(
        'POST',
        {
          path,
          params: { hotelId: hotelId.toString() },
        },
        payload
      ) as Promise<void>,
    onError: (err) => {
      message.error('Error saving add on');
    },
  });
}
